// extracted by mini-css-extract-plugin
module.exports = {"wsn2i55":"wsn2i55"};